import { Controller } from 'stimulus';
import SignaturePad from 'signature_pad/dist/signature_pad';

const createCanvas = (width, height) => {
  const canvas = document.createElement('canvas');
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  canvas.setAttribute('width', width);
  canvas.setAttribute('height', height);
  canvas.setAttribute('data-target', 'signature.canvas');
  return canvas;
};

const resizeCanvas = (canvas, width, height) => {
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  canvas.width = width * ratio;
  canvas.height = height * ratio;
  canvas.getContext('2d').scale(ratio, ratio);
};

class SignatureController extends Controller {
  connect() {
    this.width = 360;
    this.height = 150;

    const canvas = createCanvas(this.width, this.height);
    this.element.appendChild(canvas);

    this.signaturePad = new SignaturePad(this.canvasTarget, {
      onEnd: this.onEnd.bind(this),
      minWidth: 1,
      maxWidth: 2,
    });

    resizeCanvas(canvas, this.width, this.height);
    this.clearCanvas();
    this.onEnd();
  }

  onEnd() {
    // Write PNG data URL to hidden input field
    this.outputTarget.value = !this.signaturePad.isEmpty()
      ? this.signaturePad.toDataURL()
      : '';
  }

  clearCanvas() {
    this.signaturePad.clear();
  }
}

SignatureController.targets = [
  'output',
  'canvas',
];

export default SignatureController;
